// extracted by mini-css-extract-plugin
export default {"divMessage":"Message_divMessage__BgPM-"};